module.exports = __webpack_public_path__ + "static/media/roll-dice-80.fd1d985c.png";